export default __webpack_public_path__ + "static/media/myseenlogo.7f186e64.png";